// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eyWPNpVE3yefMmnwpITi{padding-top:4em;width:100%;height:100%}.eyWPNpVE3yefMmnwpITi .bsKWgdbe3S5BLxvI25Ta{display:flex;flex-direction:column;gap:2em;justify-content:center}.eyWPNpVE3yefMmnwpITi .bsKWgdbe3S5BLxvI25Ta .mP0qmrbFEToCEZdAhUH2{display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;width:100%;gap:2em;border:1px solid #91dcfa;border-radius:20px;padding:1em}.eyWPNpVE3yefMmnwpITi .bsKWgdbe3S5BLxvI25Ta .mP0qmrbFEToCEZdAhUH2 .maImMj7dtFsf8xjWYjWA,.eyWPNpVE3yefMmnwpITi .bsKWgdbe3S5BLxvI25Ta .mP0qmrbFEToCEZdAhUH2 ._yv8Pq3AKT8KQBSyhZHT{flex:1 1 50%}.eyWPNpVE3yefMmnwpITi .bsKWgdbe3S5BLxvI25Ta .mP0qmrbFEToCEZdAhUH2 ._yv8Pq3AKT8KQBSyhZHT{display:flex;flex-direction:row;padding-top:1em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"pageWrapper": `eyWPNpVE3yefMmnwpITi`,
	"blocksWrapper": `bsKWgdbe3S5BLxvI25Ta`,
	"blockWrapper": `mP0qmrbFEToCEZdAhUH2`,
	"descriptionWrapper": `maImMj7dtFsf8xjWYjWA`,
	"audioWrapper": `_yv8Pq3AKT8KQBSyhZHT`
};
export default ___CSS_LOADER_EXPORT___;
